"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductexchangeinitRequest = void 0;
var ProductexchangeinitRequest = /** @class */ (function () {
    function ProductexchangeinitRequest() {
    }
    return ProductexchangeinitRequest;
}());
exports.ProductexchangeinitRequest = ProductexchangeinitRequest;
;
//# sourceMappingURL=productexchangeinit.request.js.map